import { render, staticRenderFns } from "./alerts-counter-header.vue?vue&type=template&id=bf3840e6&scoped=true&lang=pug&"
import script from "./alerts-counter-header.vue?vue&type=script&lang=ts&"
export * from "./alerts-counter-header.vue?vue&type=script&lang=ts&"
import style0 from "./alerts-counter-header.vue?vue&type=style&index=0&id=bf3840e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3840e6",
  null
  
)

export default component.exports